import React, { Component } from 'react'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import { FormattedDate } from "react-intl";
import { SingleDatePicker } from "react-dates";
import 'react-dates/lib/css/_datepicker.css'
import moment from "moment-timezone"
import Icon from "../icon/icon.component.jsx";
import ActionButton from "../button/actionbutton.component.jsx";
import { isInclusivelyBeforeDay } from 'react-dates';
import {connect} from "react-redux"
import {StockDocumentAction} from "../../state/inventory/stockdocument/actions"
import {STOCK_DOCUMENT} from "../../utils/inventory"

const uuidv4 = require('uuid/v4')

class InlineEditDate extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            date: this.props.value ? moment(this.props.value) : null,
            popupClassName: this.props.popupClassName || '',
            popupStyle: this.props.popupStyle || {},
            currentDate: this.props.value || '',
            dateOnly: this.props.dateOnly || false,
            endPoint: this.props.endPoint || '',
            field: this.props.field || '',
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function () { },
            isLoading: false,
            success: false,
            futureDatesDisabled: this.props.futureDatesDisabled || false,
        }
        this.triggerEdit = this.triggerEdit.bind(this)
        this.onSave = this.props.onSave || function () { }
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            date: nextProps.value ? moment(nextProps.value) : null,
            currentDate: nextProps.value || '',
            status: nextProps.status || '',
            invoiceId: nextProps.invoiceId || null,
        })
    }

    componentDidMount() { }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    save(event) {
        event.preventDefault()
        this.setState({
            isLoading: true,
        })
        AppContext.getApiClient().patch(this.state.endPoint, {
            [this.state.field]: this.state.date.format(),
        }).then((r) => {
            if (this.state.endPoint.includes(STOCK_DOCUMENT)) {
                this.props.dispatch(StockDocumentAction.fetchSuccess(r))
            }
            this.setState({
                currentDate: r.attributes[this.state.field],
                editMode: false,
                isLoading: false,
                success: !r.error,
            }, () => {
                this.onSave(this.state.date.format())
                setTimeout(() => {
                    this.setState({
                        success: false,
                    })
                }, 1500)
            })
        })
    }

    startingToday(day) {
        return !isInclusivelyBeforeDay(day, moment())
    }

    render() {
        let date = <FormattedDate
            year='numeric'
            month='long'
            day='numeric'
            value={new Date(this.state.currentDate)} />

        if (!this.state.currentDate) {
            date = '-'
        }

        if (this.state.editable) {
            let link = <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
                {date} {!this.state.success ? <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} /> :
                    <Icon value={'check'} className={'ml-1 ' + (!this.state.hover ? 'text-success short-fade-out' : '')} />}
            </a>
            date = <span>
                {link}
                <div style={{
                    ...this.state.popupStyle,
                    minWidth: '250px'
                }}
                    className={this.state.popupClassName + " dropdown-menu p-4 col-md-4 " + (this.state.editMode ? 'show' : '')}>
                    <div className="w-100 m-0">
                        <SingleDatePicker
                            small
                            block
                            displayFormat="LL"
                            focused={this.state.focused}
                            isOutsideRange={day => {
                                if (this.state.futureDatesDisabled) {
                                    return this.startingToday(day)
                                }
                                return false
                            }}
                            onDateChange={(date) => {
                                if (!date) {
                                    date = moment(this.state.date)
                                }

                                const currentDate = moment()
                                this.setState({
                                    //convert the default time of the date picker to current time
                                    date: date.set({ 'hour': currentDate.hour(), 'minute': currentDate.minutes(), 'second': currentDate.seconds() }),
                                })
                            }}
                            onFocusChange={({ focused }) => this.setState({ focused })}
                            date={this.state.date}
                            numberOfMonths={1}
                        />
                    </div>
                    <p className="m-0 pt-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                            <Icon value={"arrow-left"} />
                        </button>
                        <ActionButton
                            className="btn btn-sm btn-outline-primary ml-2"
                            onClick={this.save}
                            isLoading={this.state.isLoading}>
                            <Icon value={"save"} />
                        </ActionButton>
                    </p>
                </div>
            </span>
        }

        return date
    }

}


const mapState = (state, props) => {
    return { ...props }
}
const mapDispatch = (dispatch) => {
    return {dispatch : dispatch}
}

export default connect(mapState, mapDispatch)(InlineEditDate)





// WEBPACK FOOTER //
// ./src/common/inline-edit/date.component.jsx